export interface IComputedMetric {
  id?: number;
  name?: string;
  formula?: string | null;
}

export const defaultValue: Readonly<IComputedMetric> = {};
